import { useToggle } from "react-use";
import { autoHyphen } from "../../util/common";
import VerificationInput from "../user/VerificationInput";
import { useState } from "react";

const MyInfoVerification = ({ data: d }) => {
  const [on, toggle] = useToggle(false);
  const [email, setEmail] = useState(d.email);
  const [tel, setTel] = useState(d.tel);
  return (
    <div className="flex flex-col justify-center mt-2 border rounded-xl pb-2 px-4 gap-2 w-full">
      <div
        className={`inline-flex items-center justify-between mt-1 swap ${
          on && "swap-active"
        }`}
      >
        <label className="label font-bold text-primary">인증 정보</label>
        {!on && (
          <button
            className={`btn btn-primary btn-outline btn-sm min-h-[2rem] swap-off ${
              on && "hidden"
            }`}
            onClick={toggle}
          >
            변경
          </button>
        )}
      </div>
      <div className="inline-flex items-baseline gap-2 min-h-[2rem]">
        <label className="text-sm font-bold w-16 text-end">이메일</label>
        {!on && <span>{email || "-"}</span>}
        {on && (
          <div className={`flex flex-col justify-start w-full md:w-2/3`}>
            <VerificationInput
              id={d.user_id}
              type="email"
              data={email}
              setData={setEmail}
              className={`h-10 text-sm`}
              afterSave={() => toggle()}
            />
          </div>
        )}
      </div>
      <div className="inline-flex items-baseline gap-2 min-h-[2rem]">
        <label className="text-sm font-bold w-16 text-end">휴대전화</label>
        {!on && <span>{tel ? autoHyphen(tel) : "-"}</span>}
        {on && (
          <div className={`flex flex-col justify-start w-full md:w-2/3`}>
            <VerificationInput
              id={d.user_id}
              type="tel"
              data={tel}
              setData={setTel}
              className={`h-10 text-sm`}
              afterSave={() => toggle()}
            />
          </div>
        )}
      </div>
      {on && (
        <div className="inline-flex items-center gap-2 w-full ml-[4.5rem] md:w-2/3">
          <div className="inline-flex gap-2 w-full">
            <button className="btn btn-sm flex-auto" onClick={toggle}>
              취소
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyInfoVerification;
